import request from '@/utils/request'

export function sendCode (data) {
    return request({
        url: '/sendCode',
        method: 'post',
        data
    })
}

export function getSalesList (params) {
    return request({
        url: '/sales',
        method: 'get',
        params
    })
}

export function apply (data) {
    return request({
        url: '/users',
        method: 'post',
        data
    })
}

export function login (data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}

export function getUserInfo (params) {
    return request({
        url: '/getUserInfo',
        method: 'get',
        params
    })
}

export function getSupplier (params) {
    return request({
        url: '/Supplier',
        method: 'get',
        params
    })
}


export function gSupplierRead (id) {
    return request({
        url: '/Supplier/' + id,
        method: 'get'
    })
}

export function saveSupplier (data) {
    return request({
        url: '/Supplier',
        method: 'post',
        data
    })
}

export function updateSupplier (id, data) {
    return request({
        url: '/Supplier/' + id,
        method: 'put',
        data
    })
}

export function deleteSupplier (id) {
    return request({
        url: '/Supplier/' + id,
        method: 'delete'
    })
}

export function editSupplier (id, data) {
    return request({
        url: '/edit/supplier/' + id,
        method: 'put',
        data
    })
}



export function getUseSceneList(params) {
    return request({
        url: '/admin/useScene',
        method: 'get',
        params
    })
}

export function getUseSceneInfo(id) {
    return request({
        url: '/admin/useScene/'+id,
        method: 'get'
    })
}

export function postUseScene(data) {
    return request({
        url: '/admin/useScene',
        method: 'post',
        data
    })
}

export function putUseScene(id, data) {
    return request({
        url: '/admin/useScene/'+id,
        method: 'put',
        data
    })
}

export function deleteUseScene(id) {
    return request({
        url: '/admin/useScene/'+id,
        method: 'delete'
    })
}

export function getGuidanceList(params) {
    return request({
        url: '/guidance',
        method: 'get',
        params
    })
}

export function getSupplierModel (params) {
    return request({
        url: '/SupplierModel',
        method: 'get',
        params
    })
}


export function gSupplierModelRead (id) {
    return request({
        url: '/SupplierModel/' + id,
        method: 'get'
    })
}

export function saveSupplierModel (data) {
    return request({
        url: '/SupplierModel',
        method: 'post',
        data
    })
}

export function updateSupplierModel (id, data) {
    return request({
        url: '/SupplierModel/' + id,
        method: 'put',
        data
    })
}

export function deleteSupplierModel (id) {
    return request({
        url: '/SupplierModel/' + id,
        method: 'delete'
    })
}

export function editSupplierModel (id, data) {
    return request({
        url: '/edit/supplierModel/' + id,
        method: 'put',
        data
    })
}

/**
 * 获取用户试用列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回用户试用列表的Promise
 */
export function getUserTryList(params) {
    return request({
      url: '/users',
      method: 'get',
      params
    });
  }
  
export function updateUserTryStatus(id, data) {
    return request({
        url: `/users/${id}`,
        method: 'put',
        data
    })
}

  /**
   * 获取用户试用详情
   * @param {Number} id - 试用ID
   * @returns {Promise} - 返回用户试用详情的Promise
   */
  export function getUserTryDetail(id) {
    return request({
      url: `/users/${id}`,
      method: 'get'
    });
  }
  
  /**
   * 删除用户试用申请
   * @param {Number} id - 试用ID
   * @returns {Promise} - 返回删除结果的Promise
   */
  export function deleteUserTry(id) {
    return request({
      url: `/users/${id}`,
      method: 'delete'
    });
  }

  export function extendUserTry(id, data) {
    return request({
      url: `/users/${id}/extend`,
      method: 'put',
      data
    })
}
  
export function getUserInfoByToken(params) {
    return request({
        url: `getUserInfoByToken`,
        method: 'get',
        params
    })
}

// 创建账号
export function createAccount(data) {
  return request({
    url: '/createAccount',
    method: 'post',
    data
  })
}

// 编辑账号
export function updateAccount(id, data) {
    return request({
        url: `users/editAccount/${id}`,
        method: 'put',
        data
    })
}

// 获取用户绑定模型
export function getUserSupplierModels(id,params) {
    return request({
        url: `getUserSupplierModels/${id}`,
        method: 'get',
        params
    })
}


export function getRecentlyUsed(params) {
    return request({
        url: `RecentlyUsed`,
        method: 'get',
        params
    })
}

export function getCreated(params) {
    return request({
        url: `Created`,
        method: 'get',
        params
    })
}

export function getCollectRecord(params) {
    return request({
        url: `CollectRecord`,
        method: 'get',
        params
    })
}